import {
  Badge,
  Box,
  Container,
  Flex,
  Heading,
  Text,
  useColorModeValue,
  VStack,
} from "@chakra-ui/react"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import AddProductionOrder from "../../../../components/WMS/ProductionOrders/AddProductionOrder"

export const Route = createFileRoute("/_layout/WMS/production-orders/create")({
  component: CreateProductionOrderPage,
})

function CreateProductionOrderPage() {
  const navigate = useNavigate()
  const panelBg = useColorModeValue("white", "gray.800")
  const panelBorder = useColorModeValue("gray.200", "whiteAlpha.200")

  return (
    <Container maxW="9xl" py={4}>
      <VStack spacing={4} align="stretch">
        <Box
          bgGradient="linear(to-r, teal.600, blue.600)"
          color="white"
          borderRadius="2xl"
          px={{ base: 5, md: 8 }}
          py={{ base: 5, md: 7 }}
          boxShadow="lg"
        >
          <Flex
            direction={{ base: "column", md: "row" }}
            justify="space-between"
            align={{ base: "flex-start", md: "center" }}
            gap={4}
          >
            <Box>
              <Heading size="lg">Stworzyć zlecenie</Heading>
              <Text mt={1} opacity={0.95}>
                Konfiguracja zlecenia produkcyjnego: technologia, maszyna i plan
                realizacji.
              </Text>
            </Box>
            <Badge
              bg="whiteAlpha.250"
              color="white"
              borderRadius="full"
              px={3}
              py={1}
            >
              Tworzenie produkcji
            </Badge>
          </Flex>
        </Box>

        <Box
          bg={panelBg}
          borderWidth="1px"
          borderColor={panelBorder}
          borderRadius="2xl"
          p={{ base: 4, md: 5 }}
          boxShadow="sm"
        >
          <AddProductionOrder
            onSuccess={() =>
              navigate({
                to: "/WMS/production-orders/production-orders-list",
                search: { page: 1, page_size: 25 },
              })
            }
            onCancel={() =>
              navigate({
                to: "/WMS/production-orders/production-orders-list",
                search: { page: 1, page_size: 25 },
              })
            }
          />
        </Box>
      </VStack>
    </Container>
  )
}
